import type { IconButtonProps } from '@mui/material';
import { StarFilledIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from './IconButton';

const QuickDialIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.quick_dial', 'Quick Dial');

    return (
      <IconButton ref={ref} {...props} tooltipTitle={tooltipTitle}>
        <StarFilledIcon />
      </IconButton>
    );
  },
);

QuickDialIconButton.displayName = 'QuickDialIconButton';
export default QuickDialIconButton;
